interface ContactsModalProps {
  isOpen: boolean
  onClose: () => void
}

function ContactsModal({ isOpen, onClose }: ContactsModalProps) {
  if (!isOpen) return null

  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 z-50 flex items-center justify-center p-4" onClick={onClose}>
      <div 
        className="bg-white rounded-lg max-w-md w-full max-h-[90vh] overflow-y-auto shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="sticky top-0 bg-white border-b border-gray-200 p-6 flex justify-between items-center">
          <h3 className="text-2xl font-bold text-black">КОНТАКТЫ</h3>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-black text-3xl leading-none transition-colors"
          >
            ×
          </button>
        </div>
        
        <div className="p-8 text-center">
          <div className="text-xl font-semibold text-[#1E2B3C] mb-4">
            Связаться с нами:
          </div>
          <a 
            href="mailto:planer.intent@gmail.com" 
            className="text-2xl font-bold text-[#F45B3C] hover:text-[#D32F2F] transition-colors"
          >
            planer.intent@gmail.com
          </a>
        </div>
      </div>
    </div>
  )
}

export default ContactsModal
